var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a685cc8c-32ba-4d54-91da-3a125cb58ded",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#32BEDD;}\n\t.st1{fill:#9CEBFF;}\n\t.st2{fill:#50E6FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.5,5.3 15.5,12.7 9,16.5 9,9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.5,5.3 9,9 2.5,5.3 9,1.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9,9 9,16.5 2.5,12.7 2.5,5.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2.5,12.7 9,9 9,16.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15.5,12.7 9,9 9,16.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.f61dd24442febce3d5d1fd64c080ba7f.svg";
export { ForwardRef as ReactComponent };